import { useState, useEffect, useCallback } from "react"
import { createPortal } from "react-dom"
import PropTypes from "prop-types"

import classNames from "classnames"
import UpgradePlanModal from "./upgrade_plan_modal"
import { isPaidTier } from "shared/utils/tiers"

const PlanUpgradeButton = ({
  buttonOnColor,
  currentTier,
  eligibleForTrial,
  eligibleTrialPeriod,
  isTrialing,
  newProPlusSubscriptionUrl,
  proPlusProductId,
  signedIn,
  subscriptionPaymentType,
  trackLocation,
  upgradePath,
}) => {
  const upgrading = !!window.App.user?.id && isPaidTier(currentTier) && signedIn
  const [showModal, setShowModal] = useState(false)

  const toggleModal = useCallback(() => {
    setShowModal(!showModal)
  }, [showModal])

  useEffect(() => {
    const erbOverlay = document.querySelector(".link_overlay.js-handle")

    if (erbOverlay) {
      erbOverlay.addEventListener("click", toggleModal)

      return () => erbOverlay.removeEventListener("click", toggleModal)
    }
  }, [toggleModal])

  const cta = eligibleForTrial ? "Try it free" : "Get Pro+"

  return (
    <>
      {upgrading && createPortal(
        <UpgradePlanModal
          onClose={() => toggleModal()}
          onUpgrade={() => (window.location = upgradePath)}
          proPlusProductId={proPlusProductId}
          step="plan_upgrade"
          tierRequirement="pro"
          trackLocation={trackLocation}
          user={{
            eligibleForTrial,
            eligibleTrialPeriod,
            isTrialing,
            subscriptionPaymentType,
            tier: currentTier,
          }}
          visible={showModal}
        />,
        document.body
      )}
      <a
        href={upgrading ? undefined : newProPlusSubscriptionUrl}
        onClick={upgrading ? () => toggleModal() : undefined}
        className={classNames("button-secondary", {
          "button-on-color": buttonOnColor,
        })}
        data-plan-page={!upgrading}
        title={cta}
      >
        {cta}
      </a>
    </>
  )
}

PlanUpgradeButton.propTypes = {
  buttonOnColor: PropTypes.bool,
  currentTier: PropTypes.string,
  eligibleForTrial: PropTypes.bool,
  eligibleTrialPeriod: PropTypes.number,
  isTrialing: PropTypes.bool,
  newProPlusSubscriptionUrl: PropTypes.string.isRequired,
  proPlusProductId: PropTypes.string.isRequired,
  signedIn: PropTypes.bool,
  subscriptionPaymentType: PropTypes.string,
  trackLocation: PropTypes.string,
  upgradePath: PropTypes.string,
}

PlanUpgradeButton.defaultProps = {
  buttonOnColor: false,
  eligibleTrialPeriod: 0,
}

export default PlanUpgradeButton
